/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Method_Email_DescriptionInputs */



/**
* | output |
* | --- |
* | "The invitation link and the \"Recover account\" reset link. Switch this off for a member who should only sign in through an identity provider." |
*
* @param {Member_Login_Method_Email_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_method_email_description = /** @type {((inputs?: Member_Login_Method_Email_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Method_Email_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Einladungslink und der Link aus „Konto wiederherstellen“. Schalten Sie das für Mitglieder ab, die sich ausschließlich über einen Identitätsanbieter anmelden sollen.")
	return /** @type {LocalizedString} */ ("The invitation link and the \"Recover account\" reset link. Switch this off for a member who should only sign in through an identity provider.")
});